export enum DatesConst {
  FULL_DATE = 'yyyy-MM-dd',
  FULL_DATE_WITH_HOURS = 'dd-MM-yyyy hh:mm',
}
